import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getQuizathonStart } from "../../redux/quizathon/reducer";
import {
  selectQuizathonList,
  quizathonListLoading,
} from "../../redux/quizathon/selectors";
import usePaginationWrapper from "../general/usePaginationWrapper";

const useQuizathonListGet = () => {
  const dispatch = useDispatch();
  const loadingQuizathonList = useSelector(quizathonListLoading);
  const quizathonList = useSelector(selectQuizathonList);

  const [fetch, setFetch] = useState(0);

  const {
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  } = usePaginationWrapper({ defaultLimit: 10 });

  const refetch = useCallback(() => setFetch((prev) => prev + 1), []);

  const fetchQuizathonList = useCallback(() => {
    dispatch(
      getQuizathonStart({
        keyword: debouncedSearchText,
        size: limit,
        page: (page - 1) ,
      })
    );
  }, [dispatch, page, limit, debouncedSearchText]);

  useEffect(() => {
    fetchQuizathonList();
  }, [fetchQuizathonList, fetch]);

  useEffect(() => {
    if (quizathonList) {
      setPageable({
        total_elements: quizathonList?.count,
        total_pages: quizathonList?.pages,
        number_of_elements: quizathonList?.items?.length,
      });
    }
  }, [quizathonList, setPageable]);

  return {
    quizathonList,
    loadingQuizathonList,
    refetch,
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  };
};

export default useQuizathonListGet;
